import { Component } from '@angular/core';
import { ThemeConfigureService } from '../shared/services/theme-configure-service/theme-configure-service';
import { ConfiguratorService } from '../shared/services/configurator-service/configurator.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  footerLogo!: string | undefined;
  constructor(private configuratorService: ConfiguratorService) {}
  ngOnInit() {
    // this.configuratorService.getAppConfigurationDetail().subscribe((data: any) => {
    //   const themeConfig: any = data.data;
    //   this.footerLogo = themeConfig?.footerLogo ?? '../assets/image/logo2.png';
    // })
  }
}
